<div class="tab-pane" role="tabpanel" id="formulario17" style="margin-left: -125px">
    <fieldset id="agregar_formulario17" class="">
        <div class="container" id="center_div">
            <div class="row">
                <div class="col-md-12">
                    <div id='page1' class="contenedorFormulario print-wrap page1">
                        <div>
                            <span style="float: right; clear: right;">(S.R.A.V.S. 5.2.6. / 6.1.11)</span> Formulario 1.7
                            <span style="float: right; clear: right;">1/2</span>
                        </div>
                        <h1><strong>SOLICITUD DE RECEPCION DEFINITIVA DE OBRA MENOR DE AMPLIACION DE VIVIENDA SOCIAL</strong></h1>
                        <br />
                        <div class="row">
                            <div class="col-md-4">
                                &nbsp;
                            </div>
                            <div class="col-md-4">
                                <h2 class="infObligatorios">
                                    <strong> DIRECCION DE OBRAS - MUNICIPALIDAD DE {{nombreMuni | uppercase}}</strong></h2>
                                <h2 class="infObligatorios"> {{region}} </h2>
                                <table class="tablaConBorde">
                                    <tr>
                                        <td>
                                            <span>&nbsp;</span><span>&nbsp;</span><span>&nbsp;</span><span>&nbsp;</span><span>&nbsp;</span>
                                            <span>&nbsp;</span><span>&nbsp;</span><span>&nbsp;</span><span>&nbsp;</span><span>&nbsp;</span>
                                            <input disabled class="urb" type="checkbox" name="tpradio" id="tpradio" [checked]="propiedad[0].ubicacion == 'urbano'" [checked]="propiedad[0].ubicacion == 'URBANO'" />
                                            <label for="tpradio">URBANO</label>
                                            <span>&nbsp;</span><span>&nbsp;</span><span>&nbsp;</span><span>&nbsp;</span><span>&nbsp;</span>
                                            <span>&nbsp;</span><span>&nbsp;</span><span>&nbsp;</span><span>&nbsp;</span><span>&nbsp;</span>
                                            <span>&nbsp;</span><span>&nbsp;</span><span>&nbsp;</span><span>&nbsp;</span><span>&nbsp;</span>
                                            <input disabled class="urb" type="checkbox" name="tpradio" id="tpradio" [checked]="propiedad[0].ubicacion == 'rural'" [checked]="propiedad[0].ubicacion == 'RURAL'" />
                                            <label for="tpradio">RURAL</label>
                                            <span>&nbsp;</span><span>&nbsp;</span><span>&nbsp;</span><span>&nbsp;</span><span>&nbsp;</span>
                                            <span>&nbsp;</span><span>&nbsp;</span><span>&nbsp;</span><span>&nbsp;</span><span>&nbsp;</span>
                                        </td>
                                    </tr>
                                </table>
                            </div>
                            <div class="col-md-4">
                                <table style="float: right; clear: right; width: 140px;" class="tablaConBorde table">
                                    <tbody>
                                        <tr>
                                            <td align="center" class="fondoResaltado">
                                                N&Uacute;MERO SOLICITUD
                                            </td>
                                        </tr>
                                        <tr>
                                            <td align="center">
                                                <input class="form-control" type="text" id="num_sol" value="" name="num_sol" disabled />
                                            </td>
                                        </tr>
                                        <tr>
                                            <td align="center" class="fondoResaltado">
                                                Fecha de Ingreso
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>
                                                <input class="form-control" type="text" id="fecha_ingreso" value="" name="fecha_ingreso" disabled />
                                            </td>
                                        </tr>
                                    </tbody>
                                    <tfoot>
                                        <tr>
                                            <td class="letraChica">
                                                * A LLENAR POR LA D.O.M
                                            </td>
                                        </tr>
                                    </tfoot>
                                </table>
                            </div>
                        </div>
                        <br />
                        <div>
                            <table style="width: 100%;" class="tablaConBorde table">

                                <tr>
                                    <td class="fondoResaltado izquierda" style="width: 30%; vertical-align: middle">
                                        TIPO SOLICITUD:
                                    </td>
                                    <td style="vertical-align: middle; width: 3%" align="center"><input disabled class="form-check-inline" type="checkbox" name="tipo_recepcion" id="tipo_recepcion" [checked]="tipo_recepcion[0].option == 'RECEPCION DEFINITIVA PARCIAL'" /></td>
                                    <td class="fondoResaltado" style="vertical-align: middle; width: 32%">
                                        RECEPCION DEFINITIVA PARCIAL
                                    </td>
                                    <td style="vertical-align: middle; width: 3%" align="center"><input disabled class="form-check-inline" type="checkbox" name="tipo_recepcion" id="tipo_recepcion" [checked]="tipo_recepcion[0].option == 'RECEPCION DEFINITIVA TOTAL'" /></td>
                                    <td class="fondoResaltado" style="vertical-align: middle; width: 32%">
                                        RECEPCION DEFINITIVA TOTAL
                                    </td>

                                </tr>

                            </table>
                        </div>
                        <div>
                            <div class="tituloSeccion">
                                <span> 1.- DIRECCI&Oacute;N DE LA PROPIEDAD</span>
                                <span class="help-block"></span>
                            </div>
                            <table style="width: 100%" border="0" class="tablaConBorde table">
                                <tr class="fondoResaltado">
                                    <td style="width: 57%" colspan="3">
                                        CALLE O CAMINO
                                    </td>
                                    <td style="width: 24%">
                                        N&Uacute;MERO
                                    </td>
                                    <td style="width: 19%">
                                        ROL SII
                                    </td>
                                </tr>
                                <tr>
                                    <td colspan="3">
                                        <input disabled class="form-control" id="calle" name="calle" type="text" [(ngModel)]="propiedad[0].calle" />
                                    </td>
                                    <td>
                                        <input disabled class="form-control" id="numero" name="numero" type="text" [(ngModel)]="propiedad[0].calle_num" />
                                    </td>
                                    <td>
                                        <input disabled class="form-control" id="rol" name="rol" type="text" [(ngModel)]="propiedad[0].rol" />
                                    </td>

                                </tr>
                                <tr class="fondoResaltado">
                                    <td style="width: 11%">
                                        MANZANA
                                    </td>
                                    <td style="width: 10%">
                                        LOTE
                                    </td>
                                    <td style="width: 61%" colspan="2">
                                        LOTEO O LOCALIDAD
                                    </td>
                                    <td style="width: 18%">
                                        PLANO DE LOTEO N°
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        <input disabled class="form-control" id="manzana" name="manzana" type="text" [(ngModel)]="propiedad[0].manzana" />
                                    </td>
                                    <td>
                                        <input disabled class="form-control" name="lote" id="lote" type="text" [(ngModel)]="propiedad[0].lote" />
                                    </td>
                                    <td colspan="2">
                                        <input disabled class="form-control" id="localidad" name="localidad" type="text" [(ngModel)]="propiedad[0].localidad" />
                                    </td>
                                    <td>
                                        <input disabled class="form-control" id="loteo_numero" name="loteo_numero" type="text" [(ngModel)]="propiedad[0].loteo_numero" />
                                    </td>
                                </tr>
                            </table>

                        </div>
                        <div>
                            <div class="tituloSeccion">
                                <span>2.- DATOS DEL PROPIETARIO</span>
                                <span class="help-block"></span>
                            </div>
                            <table class="tablaConBorde table form-group clone1">
                                <tr class="fondoResaltado">
                                    <td colspan="2" style="width: 65%">
                                        NOMBRE DEL PROPIETARIO
                                    </td>
                                    <td>
                                        R.U.T.
                                    </td>
                                    <td>
                                        FIRMA DEL PROPIETARIO
                                    </td>
                                </tr>
                                <tr>
                                    <td colspan="2">
                                        <input disabled class="form-control" readonly id="nombre_prop" name="nombre_prop" type="text" [(ngModel)]="propietarios[0].nombre" />
                                    </td>
                                    <td>
                                        <input disabled class="form-control" id="rut_prop" name="rut_prop" type="text" [(ngModel)]="propietarios[0].rut" />
                                    </td>
                                    <td rowspan="7">

                                    </td>

                                </tr>
                                <tr class="fondoResaltado">
                                    <td colspan="2" style="width: 65%">
                                        REPRESENTANTE LEGAL
                                    </td>
                                    <td>
                                        R.U.T.
                                    </td>
                                </tr>
                                <tr>
                                    <td colspan="2"><input disabled class="form-control" readonly id="nombre_rep" name="nombre_rep" type="text" [(ngModel)]="representantes[0].nombre" /></td>
                                    <td><input disabled class="form-control" id="rut_rep" name="rut_rep" type="text" [(ngModel)]="representantes[0].rut" /></td>
                                </tr>

                                <tr class="fondoResaltado">
                                    <td style="width: 25%">
                                        DIRECCI&Oacute;N / CALLE / PASAJE
                                    </td>
                                    <td style="width: 25%">
                                        N°
                                    </td>
                                    <td style="width: 25%">
                                        COMUNA
                                    </td>
                                </tr>
                                <tr>
                                    <td style="width: 25%">
                                        <input disabled class="form-control" id="direccion" name="direccion" type="text" [(ngModel)]="propietarios[0].direccion" />
                                    </td>
                                    <td style="width: 25%">
                                        <input disabled class="form-control" id="num" name="num" type="text" [(ngModel)]="propietarios[0].direccion_num" />
                                    </td>
                                    <td style="width: 25%">
                                        <input disabled class="form-control" id="comuna" name="comuna" type="text" [(ngModel)]="propietarios[0].comuna" />
                                    </td>
                                </tr>
                                <tr class="fondoResaltado">
                                    <td>
                                        E-MAIL
                                    </td>
                                    <td>
                                        TEL&Eacute;FONO
                                    </td>
                                    <td>
                                        FAX
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        <input disabled class="form-control" id="email_prop" name="email_prop" type="email" [(ngModel)]="propietarios[0].mail" />
                                    </td>
                                    <td>
                                        <input disabled class="form-control" id="tel_prop" name="tel_prop" type="text" [(ngModel)]="propietarios[0].fono" />
                                    </td>
                                    <td>
                                        <input disabled class="form-control" id="fax_prop" name="fax_prop" type="text" [(ngModel)]="propietarios[0].fax" />
                                    </td>
                                </tr>
                                <tr class="fondoResaltado tablaConBordeExterno table">
                                    <td colspan="4">
                                        PERSONERIA DEL REPRESENTANTE LEGAL
                                    </td>

                                </tr>
                                <tr>
                                    <td>
                                        SE ACREDITA MEDIANTE
                                    </td>
                                    <td colspan="3">
                                        <input disabled class="form-control" id="acredita" name="acredita" type="text" [(ngModel)]="permiso_notariado[0].acreditacion" />
                                    </td>

                                </tr>
                                <tr>
                                    <td>
                                        DE FECHA
                                    </td>
                                    <td>
                                        <input disabled class="form-control" id="fecha_acr" name="fecha_acr" type="text" [(ngModel)]="permiso_notariado[0].fecha" />
                                    </td>
                                    <td>
                                        Y REDUCIDA A ESCRITURA PUBLICA CON FECHA
                                    </td>
                                    <td>
                                        <input disabled class="form-control" id="fecha_esc" name="fecha_esc" type="text" [(ngModel)]="permiso_notariado[0].escritura" />
                                    </td>

                                </tr>
                                <tr>
                                    <td>
                                        ANTE EL NOTARIO SR(A)
                                    </td>
                                    <td colspan="3">
                                        <input disabled class="form-control" id="notario" name="notario" type="text" [(ngModel)]="permiso_notariado[0].notario" />
                                    </td>
                                </tr>
                            </table>
                        </div>
                        <div>
                            <div class="tituloSeccion">
                                <span>3.- ARQUITECTO</span>
                                <span class="help-block"></span>
                            </div>
                            <table class="tablaConBorde table form-group clone1">
                                <tr class="fondoResaltado">
                                    <td colspan="2" style="width: 65%"><span>
                                            NOMBRE O RAZON SOCIAL DE LA EMPRESA</span><span class="letraChica">(cuando corresponda)</span>
                                    </td>
                                    <td>
                                        R.U.T.
                                    </td>
                                    <td>
                                        FIRMA
                                    </td>
                                </tr>
                                <tr>
                                    <td colspan="2">
                                        <input disabled class="form-control" readonly id="nombre_emp" name="nombre_emp" type="text" [(ngModel)]="empresas[0].nombre" />
                                    </td>
                                    <td>
                                        <input disabled class="form-control" id="rut_emp" name="rut_emp" type="text" [(ngModel)]="empresas[0].rut" />
                                    </td>
                                    <td rowspan="5"></td>

                                </tr>
                                <tr class="fondoResaltado">
                                    <td colspan="2" style="width: 65%">
                                        NOMBRE ARQUITECTO PROYECTISTA
                                    </td>
                                    <td>
                                        R.U.T.
                                    </td>
                                </tr>
                                <tr>
                                    <td colspan="2"><input disabled class="form-control" readonly id="nombre_arq" name="nombre_arq" type="text" [(ngModel)]="arquitectos[0].nombre" /></td>
                                    <td><input disabled class="form-control" id="rut_arq" name="rut_arq" type="text" [(ngModel)]="arquitectos[0].rut" /></td>
                                </tr>

                                <tr class="fondoResaltado">
                                    <td style="width: 25%">
                                        DIRECCI&Oacute;N / CALLE / PASAJE
                                    </td>
                                    <td style="width: 25%">
                                        N°
                                    </td>
                                    <td style="width: 25%">
                                        COMUNA
                                    </td>
                                </tr>
                                <tr>
                                    <td style="width: 25%">
                                        <input disabled class="form-control" id="direccion" name="direccion" type="text" [(ngModel)]="arquitectos[0].direccion" />
                                    </td>
                                    <td style="width: 25%">
                                        <input disabled class="form-control" id="num" name="num" type="text" [(ngModel)]="arquitectos[0].direccion_num" />
                                    </td>
                                    <td style="width: 25%">
                                        <input disabled class="form-control" id="comuna" name="comuna" type="text" [(ngModel)]="arquitectos[0].comuna" />
                                    </td>
                                </tr>
                                <tr class="fondoResaltado">
                                    <td>
                                        E-MAIL
                                    </td>
                                    <td>
                                        TEL&Eacute;FONO
                                    </td>
                                    <td>
                                        FAX
                                    </td>
                                    <td>
                                        PATENTE PROFESIONAL N°
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        <input disabled class="form-control" id="email_arq" name="email_arq" type="email" [(ngModel)]="arquitectos[0].mail" />
                                    </td>
                                    <td>
                                        <input disabled class="form-control" id="tel_arq" name="tel_arq" type="text" [(ngModel)]="arquitectos[0].fono" />
                                    </td>
                                    <td>
                                        <input disabled class="form-control" id="fax_arq" name="fax_arq" type="text" [(ngModel)]="arquitectos[0].fax" />
                                    </td>
                                    <td>
                                        <input disabled class="form-control" id="pat_arq" name="pat_arq" type="text" [(ngModel)]="arquitectos[0].patente" />
                                    </td>
                                </tr>
                            </table>
                        </div>
                        <div><span CLASS="letraChica">NOTA: DE HABER MAS DE UN ARQUITECTO, ADJUNTAR DOCUMENTO CON FORMATO SIMILAR AL ANTERIOR QUE CONTENGA LOS DATOS NECESARIOS</span></div>
                        <div>
                            <div class="tituloSeccion">
                                <span>4.- PERMISOS Y RESOLUCIONES</span>
                                <span class="help-block"></span>
                            </div>
                            <table class="tablaConBorde table form-group">
                                <tr class="fondoResaltado">
                                    <td colspan="2" rowspan="2">PERMISO PARA EL QUE SOLICITA ESTA RECECION</td>
                                    <td colspan="2">N°</td>
                                    <td colspan="2">FECHA</td>
                                    <td colspan="2">SUPERFICIE M2</td>
                                </tr>
                                <tr>
                                    <td colspan="2"><input disabled class="form-control" readonly id="permiso_num" name="permiso_num" type="text" [(ngModel)]="permisos[0].perm_numero" /></td>
                                    <td colspan="2"><input disabled class="form-control" readonly id="permiso_fecha" name="permiso_fecha" type="text" [(ngModel)]="permisos[0].perm_fecha" /></td>
                                    <td colspan="2"><input disabled class="form-control" readonly id="permiso_sup" name="permiso_sup" type="text" [(ngModel)]="permisos[0].superfm2" /></td>
                                </tr>
                                <tr>
                                    <td colspan="2" class="fondoResaltado" style="width: 20%">CUENTA CON MODIFICACION DE PROYECTO APROBADA</td>
                                    <td align="center" style="width: 10%"><input class="form-check-inline" type="checkbox" id="mod_aprob" name="mod_aprob" value="SI" disabled [checked]="permisos[0].modproy == 'SI'" />SI</td>
                                    <td align="center" style="width: 10%"><input class="form-check-inline" type="checkbox" id="mod_aprob" name="mod_aprob" value="NO" disabled [checked]="permisos[0].modproy == 'NO'" />NO</td>
                                    <td class="fondoResaltado" style="width: 20%">Resoluci&oacute;n N°</td>
                                    <td style="width: 10%"><input disabled class="form-control" readonly id="resolucion" name="resolucion" type="text" [(ngModel)]="permisos[0].resolucion" /></td>
                                    <td class="fondoResaltado" style="width: 20%">Fecha</td>
                                    <td style="width: 10%"><input disabled class="form-control" readonly id="fecha_resol" name="fecha_resol" type="text" [(ngModel)]="permisos[0].fecha_resol" /></td>
                                </tr>
                                <tr>
                                    <td class="fondoResaltado">PERMISO PRIMITIVO N°</td>
                                    <td><input disabled class="form-control" readonly id="perm_prim" name="perm_prim" type="text" [(ngModel)]="permisos[0].perm_prim" /></td>
                                    <td class="fondoResaltado">DE FECHA</td>
                                    <td><input disabled class="form-control" readonly id="perm_fech" name="perm_fech" type="text" [(ngModel)]="permisos[0].fecha_prim" /></td>
                                    <td class="fondoResaltado">RECEPCI&Oacute;N N°</td>
                                    <td><input disabled class="form-control" readonly id="recepcion" name="recepcion" type="text" [(ngModel)]="permisos[0].recepcion" /></td>
                                    <td class="fondoResaltado">DE FECHA</td>
                                    <td><input disabled class="form-control" readonly id="fecha_recep" name="fecha_recep" type="text" [(ngModel)]="permisos[0].fecha_recep" /></td>
                                </tr>
                            </table>
                        </div>
                        <div>
                            <div class="tituloSeccion">
                                <span>5.- RECEPCION PARCIAL</span>
                                <span class="help-block"></span>
                            </div>
                            <table class="tablaConBorde table form-group">
                                <tr>
                                    <td class="fondoResaltado col-md-4" style="vertical-align: middle; text-align: left">SUPERFICIE EDIFICADA QUE SE RECEPCIONA</td>
                                    <td class="col-md-2"><input disabled class="form-control" readonly id="superf_edif" name="superf_edif" type="text" [(ngModel)]="recepcion_parcial[0].superedif" /></td>
                                    <td class="col-md-6 sinBordes"></td>
                                </tr>
                            </table>
                            <table class="tablaConBorde table form-group">
                                <tr>
                                    <td class="fondoResaltado" style="vertical-align: middle; text-align: left">Ha habido cambios en el Proyecto Aprobado (art. 5.2.8.OGUC)</td>
                                    <td style="vertical-align: middle">
                                        <input style="margin-left: 25%; margin-right: 25%" disabled class="form-check-inline encab" type="checkbox" name="cambios" id="cambios" value="SI" [checked]="recepcion_parcial[0].cambios == 'SI'" />SI
                                    </td>
                                    <td style="vertical-align: middle">
                                        <input style="margin-left: 25%; margin-right: 25%" disabled class="form-check-inline encab" id="cambios" name="cambios" type="checkbox" value="NO" [checked]="recepcion_parcial[0].cambios == 'NO'" />NO
                                    </td>
                                </tr>
                            </table>
                        </div>
                        <br />
                        <br />
                        <br />
                        <br />
                        <br />
                    </div>
                    <div id='page2' class="contenedorFormulario print-wrap page2">
                        <div>
                            <span style="float: right; clear: right;">(S.R.A.V.S. 5.2.6. / 6.1.11)</span> Formulario 1.7
                            <span style="float: right; clear: right;">2/2</span>
                        </div>
                        <div>
                            <div class="tituloSeccion">
                                <span>6.- ANTECEDENTES QUE SE ADJUNTAN</span>
                                <span class="help-block"></span>
                                <span class="letraChica">(ART. 5.2.6 OGUC)</span>
                            </div>

                            <table class="tablaConBorde table form-group">
                                <tr class="fondoResaltado">
                                    <td style="width: 10%"></td>
                                    <td colspan="2"></td>
                                </tr>
                                <tr>
                                    <td align="center" style="width: 10%"><input type="checkbox" class="form-check-inline" id="documentos" name="documentos" checked disabled/></td>
                                    <td><span>Fotocopia de la patente municipal al dia de los Profesionales competentes</span></td>
                                </tr>
                                <tr>
                                    <td align="center" style="width: 10%"><input type="checkbox" class="form-check-inline" id="documentos" name="documentos" checked disabled/></td>
                                    <td><span>Informe del arquitecto Art. 5.2.6 O.G.U.C inciso final</span></td>
                                </tr>
                                <tr>
                                    <td align="center" style="width: 10%"><input type="checkbox" class="form-check-inline" id="documentos" name="documentos" /></td>
                                    <td><span>Planos de Obra Terminada en caso de modificaciones menores Art. 5.2.8. O.G.U.C. (cuando corresponda)</span></td>
                                </tr>
                            </table>
                        </div>
                        <br />
                        <div>
                            <div class="tituloSeccion">
                                <span>7.- CERTIFICADOS DE LAS INSTALACIONES CONTEMPLADAS EN LA OBRA: </span>
                                <span class="help-block"></span>
                                <span class="letraChica">(ART. 5.2.6 OGUC)</span>
                            </div>
                            <table class="tablaConBorde table form-group">
                                <tr>
                                    <td align="center" style="width: 10%"><input type="checkbox" class="form-check-inline" id="certificados" name="certificados" /></td>
                                    <td><span>Electricidad</span></td>
                                </tr>
                                <tr>
                                    <td align="center" style="width: 10%"><input type="checkbox" class="form-check-inline" id="certificados" name="certificados" /></td>
                                    <td><span>Agua potable</span></td>
                                </tr>
                                <tr>
                                    <td align="center" style="width: 10%"><input type="checkbox" class="form-check-inline" id="certificados" name="certificados" /></td>
                                    <td><span>Alcantarillado</span></td>
                                </tr>
                                <tr>
                                    <td align="center" style="width: 10%"><input type="checkbox" class="form-check-inline" id="certificados" name="certificados" /></td>
                                    <td><span>Gas</span></td>
                                </tr>
                                <tr>
                                    <td align="center" style="width: 10%"><input type="checkbox" class="form-check-inline" id="certificados" name="certificados" /></td>
                                    <td><span>Otros</span></td>
                                </tr>
                               
                            </table>
                        </div>

                        <br />
                        <br />
                        <br />
                        <br />
                        <br />
                        <br />
                        <br />
                        <br />
                        <br />
                        <br />
                        <br />
                        <hr />
                        <br />
                        <div>
                            <div><span style="float: right; clear: right;">(S.R.A.V.S. 5.2.6. / 6.1.11)</span></div>
                            <div>
                                <h1><strong>COMPROBANTE DE INGRESO</strong></h1>
                            </div>
                        </div>
                        <br />
                        <div>
                            <h1>SOLICITUD DE RECPCI&Oacute;N DEFINITIVA DE OBRA MENOR DE AMPLIACI&Oacute;N DE VIVIENDA SOCIAL</h1>
                        </div>
                        <br />
                        <div class="row">
                            <div class="col-md-4">
                                <table class="tablaConBordeExterno">
                                    <tr>
                                        <td>&nbsp;</td>
                                    </tr>
                                    <tr>
                                        <td>&nbsp;</td>
                                    </tr>
                                    <tr>
                                        <td>&nbsp;</td>
                                    </tr>
                                    <tr>
                                        <td>&nbsp;</td>
                                    </tr>
                                    <tr>
                                        <td>&nbsp;</td>
                                    </tr>
                                    <tr>
                                        <td>&nbsp;</td>
                                    </tr>
                                    <tr align="center">
                                        <td>FIRMA FUNCIONARIO.</td>
                                    </tr>
                                    <tr align="center">
                                        <td> Y TIMBRE D.O.M.</td>
                                    </tr>

                                </table>

                            </div>
                            <br />
                            <div class="col-md-4">
                                <h2 class="infObligatorios">
                                    <strong> DIRECCION DE OBRAS - MUNICIPALIDAD DE {{nombreMuni | uppercase}}</strong></h2>
                                <h2 class="infObligatorios"> {{region}} </h2>
                            </div>
                            <div class="col-md-4">
                                <table style="float: right; clear: right; width: 140px;" class="tablaConBorde table">
                                    <tbody>
                                        <tr>
                                            <td align="center" class="fondoResaltado">
                                                N&Uacute;MERO SOLICITUD
                                            </td>
                                        </tr>
                                        <tr>
                                            <td align="center">
                                                <input class="form-control" type="text" id="num_sol" value="" name="num_sol" disabled />
                                            </td>
                                        </tr>
                                        <tr>
                                            <td align="center" class="fondoResaltado">
                                                Fecha de Ingreso
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>
                                                <input class="form-control" type="text" id="fecha_ingreso" value="" name="fecha_ingreso" disabled />
                                            </td>
                                        </tr>
                                    </tbody>

                                </table>
                            </div>
                        </div>
                        <br />
                        <div>
                            <table class="tablaConBorde">
                                <tr class="fondoResaltado">
                                    <td>CALLE O CAMINO</td>
                                    <td>N&Uacute;MERO</td>
                                </tr>
                                <tr>
                                    <td><input class="form-control" type="text" id="calle" name="calle" disabled [(ngModel)]="propiedad[0].calle" /></td>
                                    <td><input class="form-control" type="text" id="numero" name="numero" disabled [(ngModel)]="propiedad[0].calle_num" /></td>
                                </tr>
                            </table>
                        </div>
                        <hr />
                        <br />
                        <br />
                        <br />
                        <br />
                        <br />
                    </div>
                </div>
            </div>
        </div>
        <div>
            <button mat-raised-button color="primary" id="pdf-download-link" title="Descargar Formulario 1.7" (click)="captureScreen()">Descargar Formulario 1.7</button>
        </div>
    </fieldset>
</div>